import { createContext } from 'react';
export const AuthContext = createContext(null);
//# sourceMappingURL=auth-context.js.map